import React from 'react';
import _sumBy from 'lodash/sumBy';
import './index.less';
import Row from './row';

function PayoutTable({ table, ...props }) {
	const { rows, headers } = table;
	return (
		<div
			className="table-container payout-requests-register-table"
		>
			<table className="simple-table">
				<thead className="simple-table__head font-roboto-medium">
					<tr className="top-affiliates-table-top-row">
						{
							headers
								.map((header, i) =>
									<th key={i} className={header.className || ''}>{header.title}</th>
								)
						}
					</tr>
				</thead>
				<tbody className="simple-table__body">
					{rows.map((row, index) =>
						<Row row={row} key={index} {...props} />
					)}
					<tr>
						<td></td>
						<td></td>
						<td>Total count: {_sumBy(rows, i => Number(i.count))}</td>
					</tr>
				</tbody>
			</table>
		</div>
	);
}

export default PayoutTable;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/components/table-stat/main.js